import React from 'react'
import './admin-workflows.css'
import TaskCard from '../TaskCard/TaskCard'
import StudentOnboardingTaskCard from './StudentOnboardingTaskCard/StudentOnboardingTaskCard'
import {PageCover} from '../PageCover/PageCover'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import Axios from 'axios'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import loadingping from '../img/loadingpin.svg'
import axios from 'axios'
import { createStudentWorkflowFunction2022 } from './WorkflowModels'
import WebsiteInquiryCardModal2023 from './WebsiteInquiryCardModal2023/WebsiteInquiryCardModal2023'
import FamilyInfoQuickDisplay from './FamilyInfoQuickDisplay/FamilyInfoQuickDisplay'
import StudentOnboardingTemplatesMenu from './StudentOnboardingTemplatesMenu/StudentOnboardingTemplatesMenu'
import StudentOnboardingCardModal2023 from './StudentOnboardingCardModal2023/StudentOnboardingCardModal2023'
import StudentOnboardingTemplateWorkflowsCardModal from './StudentOnboardingTemplateWorkflowsCardModal/StudentOnboardingTemplateWorkflowsCardModal'
import TempTeacherDistancePopup from './TempTeacherDistancePopup/TempTeacherDistancePopup'
import SelectFamilyIdForOnboardingCard from './SelectFamilyIdForOnboardingCard/SelectFamilyIdForOnboardingCard'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentWorkflows2022 = ({workflows, setWorkflows, ...props}) => {
        //const [workflows, setWorkflows] = React.useState([])
        const [openModal, setOpenModal] = React.useState(false)
        const [backgroundCover, setBackgroundCover] = React.useState(false)
        const [error, setError] = React.useState(false)
        const [loading, setLoading] = React.useState(false)
        const [gettingWorkflows, setGettingWorkflows] = React.useState(false)
        const [columns, setColumns] = React.useState(true)
        const [instruments, setInstruments] = React.useState([])
        const listOfSchools = ['mma', 'lsma', 'tma', 'mor', 'psma']
        const [sortedByInstrument, setSortedByInstrument] = React.useState({'mma': {}, 'lsma': {}, 'tma': {}, 'mor': {}, 'psma': {}})
        const [generalTotal, setGeneralTotal] = React.useState({'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0})
        const [dividedWorkflows, setDividedWorkflows] = React.useState({'mma': {'top': [], 'middle': [], 'bottom': []}, 'lsma': {'top': [], 'middle': [], 'bottom': []}, 'tma': {'top': [], 'middle': [], 'bottom': []}, 'mor': {'top': [], 'middle': [], 'bottom': []}, 'psma': {'top': [], 'middle': [], 'bottom': []}, 'all': {'top': [], 'middle': [], 'bottom': []}})
        const [quickDisplay, setQuickDisplay] = React.useState(false)
        const [templatesMenu, setTemplatesMenu] = React.useState(false)
        const [templates, setTemplates] = React.useState([])
        const [createWorkflowTemplate, setCreateWorkflowTemplate] = React.useState(false)
        const [editWorkflowTemplate, setEditWorkflowTemplate] = React.useState(false)
        const [deleteWarningPopup, setDeleteWarningPopup] = React.useState(false)
        const [openWebsiteInquiryModal2023, setOpenWebsiteInquiryModal2023] = React.useState(false)
        const [openStudentOnboardingModal2023, setOpenStudentOnboardingModal2023] = React.useState(false)
        const [workflowTemplateModal2023, setWorkflowTemplateModal2023] = React.useState(false)
        const [teacherDistanceSuggestions, setTeacherDistanceSuggestions] = React.useState([])
        const [selectFamilyToGetDistances, setSelectFamilyToGetDistances] = React.useState(false)
        const [loadingDistances, setLoadingDistances] = React.useState(false)
        const [scheduledTotal, setScheduledTotal] = React.useState({'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0})

    React.useEffect(() => {
        getTodos()
        getInstruments()
    }, [])

    React.useEffect(() => {
        if(openStudentOnboardingModal2023 && teacherDistanceSuggestions.length === 0) {
            getTeacherDistanceSuggestions(openStudentOnboardingModal2023.familyId, openStudentOnboardingModal2023.whichSchool, openStudentOnboardingModal2023.todoId)
        } else {
            setTeacherDistanceSuggestions([])
        }
    }, [openStudentOnboardingModal2023])

    React.useEffect(() => {
        if(templatesMenu) {
            axios.get(`${baseUrl}/studentworkflowtemplates`, myHeader)
            .then(res => setTemplates(res.data))
            .catch(err => console.log(err))
        }
    }, [templatesMenu])

    React.useEffect(() => {
        sortWorkflows()
        tallyStudents()
        tallyStudentsWhoHaveBeenScheduled()
        setTimeout(() => {
            highlightAlreadyInUseCards()
        }, 50)
    }, [workflows, props.studentOnboardingCardsInUse])

    React.useEffect(() => {
        props.socket.on('createStudentWorkflow', (packet) => {
            if(packet.emitter !== props.userData.Name) {
                setWorkflows(prev => [...prev, packet.data])
            }
        })
        props.socket.on('closeAndSaveStudentWorkflow', (packet) => {
            if(packet.updatedCard.emitter !== props.userData.Name) {
                setWorkflows(prev => prev.map(flow => flow.todoId === packet.updatedCard.data.todoId ? packet.updatedCard.data : flow))
                props.setStudentOnboardingCardsInUse(packet.updatedList)
                //document.getElementById(packet.data.todoId).style.border = "2px solid rgba(255, 255, 255, 0.7)"
            }
        })
        props.socket.on('closeAndDeleteStudentWorkflow', (packet) => {
            if(packet.emitter !== props.userData.Name) {
                setWorkflows(prev => prev.filter(flow => flow.todoId !== packet.data))
            }
        })
    }, [props.socket])

    const getTeacherDistanceSuggestions = (familyId, school, todoId) => {
        if(familyId === "none" || familyId === null || familyId === undefined) {
            setSelectFamilyToGetDistances(todoId)
        } else {
            setLoadingDistances(true)
            axios.get(`${baseUrl}/geolocation/${familyId}/${school}/`)
            .then(res => {
                setLoadingDistances(false)
                setTeacherDistanceSuggestions(res.data)
            })
            .catch(err => console.log(err))
        }
    }

    const createANewWorkflowTemplate = () => {
        setCreateWorkflowTemplate(true)
        setEditWorkflowTemplate(false)
        setWorkflowTemplateModal2023({
            todoId: Math.random().toString(16).slice(2),
            todoName: "Customize Workflow",
            todoDescription: "Notes...",
            studentList: [],
            todoDueDate: new Date(),
            todoAlarm: false,
            todoOwner: '',
            whichList: 'student',
            whichSchool: 'all',
            todoSubtasks: [],
        }) 
        setTimeout(() => {
            cardAnimation()
        },0)
    }

    const toggleBackgroundCover = () => {
        setBackgroundCover(prev => !prev)
    }

    const sortWorkflows = () => {
        let myObj = {'mma': {}, 'lsma': {}, 'tma': {}, 'mor': {}, 'psma': {}}
        let myTotal = {'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0}
        let breakingList = {'mma': {'top': [], 'middle': [], 'bottom': []}, 'lsma': {'top': [], 'middle': [], 'bottom': []}, 'tma': {'top': [], 'middle': [], 'bottom': []}, 'mor': {'top': [], 'middle': [], 'bottom': []}, 'psma': {'top': [], 'middle': [], 'bottom': []}, 'all': {'top': [], 'middle': [], 'bottom': []}}
        for(let i = 0; i < workflows.length; i++) {
            if(workflows[i].instrumentList) {
                for(let j = 0; j < workflows[i].instrumentList.length; j++) {
                    myTotal[workflows[i].whichSchool] = myTotal[workflows[i].whichSchool] + 1
                    if(myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name]) {
                        myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] = myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] + 1
                    } else {
                        myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] = 1
                    }
                }
            }
        }
        for(let i = 0; i < workflows.length; i++) {
            let allScheduled = true
            let allCalled = true
            if(workflows[i].studentList.length === 0) {
                breakingList[workflows[i].whichSchool].top.push(workflows[i])
            } else {
                for(let j = 0; j < workflows[i].studentList.length; j++) {
                    if(workflows[i].studentList[j].introLesson.isScheduled) {
                        if(workflows[i].studentList[j].introLesson.hasBeenCalled) {
                        } else {
                            allCalled = false
                        }
                    } else {
                        allScheduled = false
                    }
                }
                if(allScheduled && allCalled) {
                    breakingList[workflows[i].whichSchool].bottom.push(workflows[i])
                } else if (allScheduled && !allCalled) {
                    breakingList[workflows[i].whichSchool].middle.push(workflows[i])
                } else if (!allScheduled && !allCalled || allCalled) {
                    breakingList[workflows[i].whichSchool].top.push(workflows[i])
                }
            }
        }
        setSortedByInstrument({...myObj})
        setDividedWorkflows({...breakingList})
        //setGeneralTotal({...myTotal})
    }
    const tallyStudents = () => {
        let myTotal = {'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0}
        for(let i = 0; i < workflows.length; i++) {
            if(workflows[i].studentList) {
                for(let j = 0; j < workflows[i].studentList.length; j++) {
                    myTotal[workflows[i].whichSchool] = myTotal[workflows[i].whichSchool] + 1
                    // if(myObj[workflows[i].whichSchool][workflows[i].studentList[j].name]) {
                    //     myObj[workflows[i].whichSchool][workflows[i].studentList[j].name] = myObj[workflows[i].whichSchool][workflows[i].studentList[j].name] + 1
                    // } else {
                    //     myObj[workflows[i].whichSchool][workflows[i].studentList[j].name] = 1
                    // }
                }
            }
        }
        setGeneralTotal({...myTotal})
    }

    const tallyStudentsWhoHaveBeenScheduled = () => {
        let myTotal = {'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0}
        for(let i = 0; i < workflows.length; i++) {
            if(workflows[i].studentList) {
                for(let j = 0; j < workflows[i].studentList.length; j++) {
                    if(workflows[i].studentList[j].introLesson.isScheduled) {
                        myTotal[workflows[i].whichSchool] = myTotal[workflows[i].whichSchool] + 1
                    }
                }
            }
        }
        setScheduledTotal({...myTotal})
    }

    const highlightAlreadyInUseCards = () => {
        for(let i = 0; i < workflows.length; i++) {
            if(document.getElementById(workflows[i].todoId)){
                if(workflows[i].whichList === 'student') {
                    document.getElementById(workflows[i].todoId).style.border = "2px solid rgba(255, 255, 255, 0.7)"
                } else if (workflows[i].whichList === 'orange') {
                    document.getElementById(workflows[i].todoId).style.border = "2px solid orange"
                } else if (workflows[i].whichList === 'blue') {
                    document.getElementById(workflows[i].todoId).style.border = "2px solid blue"
                } else if (workflows[i].whichList === 'inquiry') {
                    document.getElementById(workflows[i].todoId).style.border = "2px solid rgba(255, 255, 255, 0.7)"
                }
            }
        }
        for(let i = 0; i < props.studentOnboardingCardsInUse.length; i++) {
            if(document.getElementById(props.studentOnboardingCardsInUse[i].data)) {
                document.getElementById(props.studentOnboardingCardsInUse[i].data).style.border = "2px solid fuchsia"
            }
        }
    }

    const getTodos = async () => {
        setGettingWorkflows(true)
        Axios.get(`${baseUrl}/student-onboarding`, myHeader)
        .then(response => {
            setWorkflows(response.data)
            setLoading(false)
            setGettingWorkflows(false)
        })
        .catch(e => {
            console.log(e)
            setError({message: e.response.data, status: e.response.status})
        })
    }

    const getInstruments = () => {
        Axios.get(`${baseUrl}/inst`)
        .then((res) => setInstruments(res.data))
        .catch((err) => console.log(err))
    }

    const openTheWebsiteInquiry = (todo) => {
        props.socket.emit('openStudentWorkflow', {emitter: props.userData.Name, data:todo.todoId})
        setOpenWebsiteInquiryModal2023(todo)
        setTimeout(() => {
            props.getNotesAboutModal(todo.todoId, 'onboardingId', todo.todoName)
        }, 0) 
    }

    const openTheStudentOnboardingModal = (todo) => {
        props.socket.emit('openStudentWorkflow', {emitter: props.userData.Name, data:todo.todoId})
        setOpenStudentOnboardingModal2023(todo)
        setTimeout(() => {
            props.getNotesAboutModal(todo.todoId, 'onboardingId', todo.todoName)
        }, 0)
    }

    const closeTheStudentOnboardingModal = (todo) => {
        props.socket.emit('closeAndSaveStudentWorkflow', {emitter: props.userData.Name, data:todo.todoId})
    }

    const openTheModal = (todo) => {
        props.socket.emit('openStudentWorkflow', {emitter: props.userData.Name, data:todo.todoId})
        setOpenModal(todo)
        setTimeout(() => {
            cardAnimation()
            props.getNotesAboutModal(todo.todoId, 'onboardingId', todo.todoName)
        }, 0)
    }

    const cardAnimation = () => {
            setTimeout(() => {
                document.getElementById('card-modal-content').style.marginRight = "-600px"
            }, 0)
            setTimeout(() => {
                document.getElementById('card-modal-content').style.marginRight = "400px"
                document.getElementById('card-modal').style.backgroundColor = "rgba(0, 0, 0, 0.2)"
            }, 10);
    }

    const deleteTask = async (todo) => {
        //DELETING ALL RELATED NOTES
        for(let i = 0; i < props.sideBarNotes.length; i++) {
            if(props.sideBarNotes[i].applicationId === '' && props.sideBarNotes[i].invoiceId === '' && props.sideBarNotes[i].familyId === '' && props.sideBarNotes[i].tasksId === '' && props.sideBarNotes[i].teacherId === '' && props.sideBarNotes[i].timesheetId === '' && props.sideBarNotes[i].workflowId === '' && props.sideBarNotes[i].miscId1 === '' && props.sideBarNotes[i].miscId2 === '' && props.sideBarNotes[i].miscId3 === '' && props.sideBarNotes[i].miscId4 === '' && props.sideBarNotes[i].miscId5 === '' && props.sideBarNotes[i].miscId6 === '' && props.sideBarNotes[i].miscId7 === '' && props.sideBarNotes[i].miscId8 === '' && props.sideBarNotes[i].miscId9 === '' && props.sideBarNotes[i].miscId10 === '') {
                await axios.delete(`${baseUrl}/notes/${props.sideBarNotes[i].id}`)
                .then((res) => {
                    //console.log(res)
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        }
        //DELETING THE TODO
        setLoading("Deleting Workflow")
        Axios.delete(`${baseUrl}/student-onboarding/${todo.todoId}`, myHeader)
        .then((response) => {
            setOpenModal(false)
            props.socket.emit('closeAndDeleteStudentWorkflow', {emitter: props.userData.Name, data: todo.todoId})
            props.setShowNotes(false)
            getTodos() 
        })
        .catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }

    const signalWorkflowBeingDeleted = (workflowId) => {
        props.socket.emit('closeAndDeleteStudentWorkflow', {emitter: props.userData.Name, data: workflowId})
    }

    const changeDueDate = (theValue) => {
        setOpenModal({...openModal, todoDueDate: theValue})
    }
    const closeErrorModal = () => {
        setError(false)
    }

    const addThisWorkflow = (id) => {
        for(let i = 0; i < templates.length; i++) {
            if(id === templates[i].todoId) {
                setLoading('Creating Workflow')

                let studentWorkflow = templates[i]
        
                Axios.post(`${baseUrl}/student-onboarding`, {
                    todoId: Math.random().toString(16).slice(2),
                    todoName: studentWorkflow.todoName,
                    todoDescription: studentWorkflow.todoDescription,
                    familyId: 'none',
                    studentList: studentWorkflow.studentList,
                    todoDueDate: studentWorkflow.todoDueDate,
                    todoAlarm: studentWorkflow.todoAlarm,
                    theyHaveBeenCalled: studentWorkflow.theyHaveBeenCalled ? studentWorkflow.theyHaveBeenCalled : false,
                    todoOwner: studentWorkflow.todoOwner,
                    whichList: studentWorkflow.whichList,
                    whichSchool: studentWorkflow.whichSchool,
                    todoSubtasks: studentWorkflow.todoSubtasks
                }, myHeader)
                .then((response) => {
                    setWorkflows([...workflows, response.data])
                    props.socket.emit('createStudentWorkflow', {emitter: props.userData.Name, data: response.data})
                    setLoading(false)
                    openTheStudentOnboardingModal(response.data)
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(false)
                })
            }
        }
    }
    const deleteATemplate = (id) => {
        setDeleteWarningPopup(false)
        document.body.style.cursor = 'wait'
        axios.delete(`${baseUrl}/studentworkflowtemplates/${id}`, myHeader)
        .then((res) => {
            setTemplates(templates.filter(i => i.todoId !== res.data.todoId))
            document.body.style.cursor = 'default'
        })
        .catch((err) => {
            console.log(err)
            document.body.style.cursor = 'default'
        })
    }
    const editExistingTemplate = (id) => {
        setCreateWorkflowTemplate(true)
        setEditWorkflowTemplate(true)
        for(let i = 0; i < templates.length; i++) {
            if(id === templates[i].todoId) {
                setWorkflowTemplateModal2023(templates[i])
                setTimeout(() => {
                    cardAnimation()
                },0)
            }
        }
    }

    return (
        <div className="admin-task-page">
            <PageCover pagecover={backgroundCover} toggleBackgroundCover={toggleBackgroundCover}/>
            {deleteWarningPopup &&
            <div className='student-workflow-2022__delete-warning__popup__wrapper'>
                <div className='student-workflow-2022__delete-warning__popup'>
                    <div>Are you sure you want to delete this template?</div>
                    <div className='student-workflow-2022__delete-warning__popup__btn' onClick={() => setDeleteWarningPopup(false)}>cancel</div>
                    <div className='student-workflow-2022__delete-warning__popup__btn' onClick={() => deleteATemplate(deleteWarningPopup)}>Yes</div>
                </div>
            </div>
            }
            {templatesMenu && <StudentOnboardingTemplatesMenu setTemplatesMenu={setTemplatesMenu} addThisWorkflow={addThisWorkflow} editExistingTemplate={editExistingTemplate} setDeleteWarningPopup={setDeleteWarningPopup} createANewWorkflowTemplate={createANewWorkflowTemplate} />}
            <div className="student-onboarding__main-area">
                <div className="new-workflow-drop-down-2022">
                    <div className="create-new-workflow-btn-2022" onMouseEnter={() => setTemplatesMenu(true)}>Workflow List</div>
                </div>
                {quickDisplay && <FamilyInfoQuickDisplay quickDisplay={quickDisplay} />}
                {columns ?
                    <div>
                        {listOfSchools.map((schoolAbb) => (
                            <div key={schoolAbb} className='student-onboarding__column'>
                                <div className='student-onboarding__column__title'>{schoolAbb.toUpperCase()} {generalTotal[schoolAbb] > 0 && <span className="student-onboarding__red-circle">{generalTotal[schoolAbb]}</span>}</div>
                                {/* <div className='student-onboarding__instrument-totals__wrapper'>
                                    {Object.keys(sortedByInstrument[schoolAbb]).map((key, index) => (
                                        <div key={index} className='student-onboarding__instrument-totals__each-one'><p className='student-onboarding__instrument-totals__inst'>{key}:</p> <p className='student-onboarding__instrument-totals__total'>{sortedByInstrument[schoolAbb][key]}</p></div>
                                    ))}
                                </div> */}
                                {schoolAbb === 'psma' ?
                                    <div> 
                                        <div className='student-onboarding__scroll-column inquired'>
                                            <div className='student-onboarding__scroll-column__label'>Website Inquiry</div>
                                            <div className='student-onboarding__internal-scroll'>
                                                {workflows.map(workflow => 
                                                    (workflow.whichList === 'inquiry' && workflow.whichSchool === schoolAbb) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheWebsiteInquiry} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>                              
                                        <div className='student-onboarding__scroll-column'>
                                            <div className='student-onboarding__scroll-column__label'>Unscheduled</div>
                                            <div className='student-onboarding__internal-scroll unscheduled'>
                                                {dividedWorkflows[schoolAbb].top.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && (workflow.whichSchool === schoolAbb || workflow.whichSchool === 'all')) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                             {dividedWorkflows['all'].top.map(workflow => 
                                                (workflow.whichList !== 'inquiry' && (workflow.whichSchool === 'all')) &&
                                                <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                    <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                </div>)
                                            }
                                        </div> 
                                        <div className='student-onboarding__scroll-column'>
                                            <div className='student-onboarding__scroll-column__label'>All Scheduled {scheduledTotal[schoolAbb]}</div>
                                            <div className='student-onboarding__internal-scroll all-scheduled'>
                                                {dividedWorkflows[schoolAbb].middle.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && (workflow.whichSchool === schoolAbb || workflow.whichSchool === 'all')) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                        <div className='student-onboarding__scroll-column'>
                                            <div className='student-onboarding__scroll-column__label'>All Called</div>
                                            <div className='student-onboarding__internal-scroll all-called'>
                                                {dividedWorkflows[schoolAbb].bottom.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && (workflow.whichSchool === schoolAbb || workflow.whichSchool === 'all')) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                :    
                                    <div> 
                                        <div className='student-onboarding__scroll-column inquired'>
                                            <div className='student-onboarding__scroll-column__label'>Website Inquiry</div>
                                            <div className='student-onboarding__internal-scroll inquired'>
                                                {workflows.map(workflow => 
                                                    (workflow.whichList === 'inquiry' && workflow.whichSchool === schoolAbb) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheWebsiteInquiry} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>                            
                                        <div className='student-onboarding__scroll-column '>
                                            <div className='student-onboarding__scroll-column__label'>Unscheduled</div>
                                            <div className='student-onboarding__internal-scroll unscheduled'>
                                                {dividedWorkflows[schoolAbb].top.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && workflow.whichSchool === schoolAbb) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div> 
                                        <div className='student-onboarding__scroll-column'>
                                            <div className='student-onboarding__scroll-column__label'>All Scheduled ({scheduledTotal[schoolAbb]})</div>
                                            <div className='student-onboarding__internal-scroll all-scheduled'>
                                                {dividedWorkflows[schoolAbb].middle.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && workflow.whichSchool === schoolAbb) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                        <div className='student-onboarding__scroll-column'>
                                            <div className='student-onboarding__scroll-column__label'>All Called</div>
                                            <div className='student-onboarding__internal-scroll all-called'>
                                                {dividedWorkflows[schoolAbb].bottom.map(workflow => 
                                                    (workflow.whichList !== 'inquiry' && workflow.whichSchool === schoolAbb) &&
                                                    <div key={workflow.todoId} onMouseEnter={() => setQuickDisplay(workflow)} onMouseLeave={() => setQuickDisplay(false)}>
                                                        <StudentOnboardingTaskCard openModal={openTheStudentOnboardingModal} todo={workflow} />
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }     
                            </div>
                        ))}
                    </div> 
                    :
                    <div className="tasks-area-scroll just-scooch-it student-onboarding__no-columns">
                        {gettingWorkflows && <img className="loading-ping" alt='loading' src={loadingping} />}
                        {workflows.map(workflow => 
                            workflow.whichList !== 'inquiry' ?
                            <TaskCard 
                                whichList = 'workflows'
                                key={workflow.todoId} deleteTask={deleteTask} 
                                openModal={openTheModal} todo={workflow} 
                                changeDueDate={changeDueDate}
                                toggleBackgroundCover={toggleBackgroundCover}
                            /> : null)
                        }
                    </div>
                }
            </div>
            {openWebsiteInquiryModal2023 && <WebsiteInquiryCardModal2023 openWorkflowModal2023={openWebsiteInquiryModal2023} setOpenWorkflowModal2023={setOpenWebsiteInquiryModal2023} setWorkflows={setWorkflows} setShowNotes={props.setShowNotes} closeTheStudentOnboardingModal={closeTheStudentOnboardingModal} />}
            {openStudentOnboardingModal2023 && <StudentOnboardingCardModal2023 openWorkflowModal2023={openStudentOnboardingModal2023} setOpenWorkflowModal2023={setOpenStudentOnboardingModal2023} closeTheStudentOnboardingModal={closeTheStudentOnboardingModal} signalWorkflowBeingDeleted={signalWorkflowBeingDeleted} setWorkflows={setWorkflows} setShowNotes={props.setShowNotes} setSelectFamilyToGetDistances={setSelectFamilyToGetDistances} />}
            {workflowTemplateModal2023 && <StudentOnboardingTemplateWorkflowsCardModal workflowTemplateModal2023={workflowTemplateModal2023} setWorkflowTemplateModal2023={setWorkflowTemplateModal2023} editWorkflow={editWorkflowTemplate} setEditWorkflow={setEditWorkflowTemplate} />}
            {teacherDistanceSuggestions && <TempTeacherDistancePopup teacherDistanceSuggestions={teacherDistanceSuggestions} loadingDistances={loadingDistances} />}
            {selectFamilyToGetDistances && <SelectFamilyIdForOnboardingCard selectFamilyToGetDistances={selectFamilyToGetDistances} setSelectFamilyToGetDistances={setSelectFamilyToGetDistances} getTeacherDistanceSuggestions={getTeacherDistanceSuggestions} setOpenStudentOnboardingModal2023={setOpenStudentOnboardingModal2023} />}

            {error && <ErrorPopup error={error} setError={closeErrorModal}/>}
            {loading && <NewLoadingScreen logo="favicon.png" message={loading} />}
        </div>
    )
}


export default StudentWorkflows2022